import React, { useState,useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import swal from "sweetalert";
import $ from "jquery"
import '../../../assets/css/styles.css'; 
import '../../../assets/css/themify-icons.css'
import '../../../assets/css/default-css.css'
// import "../../../assets/css/bootstrap.min.css"
import '../../../assets/css/typography.css'

const AdminLogin2 = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [remember,setRemember]=useState(false)
    const [processing,setProcessing]=useState(false)
    const { login } = useAuth();
    const navigate = useNavigate();
    const handleLogin = async (e) => {
      setProcessing(true)
      e.preventDefault();
      try {
        await login(email, password,remember);
        navigate("/admin/dashboard");
      } catch (error) {
        if(error.message==="Network Error"){
          swal({
            text: "Unable to reach Server, please try again after some time",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          });
        }
        if(error.response){
          swal({
            text: error.response.data.message,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          });
        }
        setProcessing(false)
      }
    };
    useEffect(() => {
        $('.form-gp input').on('focus', function() {
          $(this).parent('.form-gp').addClass('focused');
        });
    
        $('.form-gp input').on('focusout', function() {
          if ($(this).val().length === 0) {
            $(this).parent('.form-gp').removeClass('focused');
          }
        });
    
        // Optionally, you can also clean up the jQuery event listeners when the component unmounts.
        return () => {
          $('.form-gp input').off('focus').off('focusout');
        };
      }, []); 
  return (
    <div>
        <div className="login-area">
        <div className="container">
            <div className="login-box ptb--100">
                <form>
                    <div className="login-form-head" style={{borderRadius:'4px'}}>
                        <h4>Sign In</h4>
                        <p>Hello there, Sign in and start managing your Admin panel</p>
                    </div>
                    <div className="login-form-body">
                        <div className="form-gp">
                            <label htmlFor="exampleInputEmail1">Email address</label>
                            <input type="email" id="exampleInputEmail1" onChange={(e) => setEmail(e.target.value)}/>
                            <i className="ti-email"></i>
                            <div className="text-danger"></div>
                        </div>
                        <div className="form-gp">
                            <label htmlFor="exampleInputPassword1">Password</label>
                            <input onChange={(e) => setPassword(e.target.value)} type={showPassword?'text':'password'} id="exampleInputPassword1"/>
                            <i className={`${showPassword ? 'ti-lock' : 'ti-key'}`}
                               onClick={() => setShowPassword(!showPassword)}
                            ></i>
                            <div className="text-danger"></div>
                        </div>
                        <div className="row mb-4 rmber-area">
                            <div className="col-lg-6">
                                <div className="custom-control custom-checkbox mr-sm-2">
                                    <input onChange={()=>setRemember(!remember)} type="checkbox" className="custom-control-input" id="customControlAutosizing"/>
                                    <label className="custom-control-label" htmlFor="customControlAutosizing">Remember Me</label>
                                </div>
                            </div>
                            {/* <div className="col-6 text-right">
                                <a href="#">Forgot Password?</a>
                            </div> */}
                        </div>
                        <div className="submit-btn-area">
                            <button  disabled={processing} id="form_submit" onClick={handleLogin} type="submit">{processing?'Loading...':'Sign In'} <i className="ti-arrow-right"></i></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </div>
  )
}

export default AdminLogin2
